import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import FromUserInfo from '@/model/modules/FromUserInfo'

export default class FromUserService extends BaseService {
  protected static baseUrl: string = '/from'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<FromUserInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<FromUserInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/list-all', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<FromUserInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  public static listWithUser(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<FromUserInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<FromUserInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<FromUserInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  public static saveGroupFromUser(groupId: number, fromUserIdList: number[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios.post('/from-user-group/save-group-user', {
        groupId: groupId,
        fromUserId: fromUserIdList
      }).then(resp => {
        resolve()
      }).catch(e => {
        reject(e)
      })
    })
  }
}
